import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/manage-payment/adyen';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/transaction`, payload);
};

const listExport = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/transaction/export`, payload, {
		responseType: 'blob',
	});
};

const listPayout = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/payout`, payload);
};

const listPayoutExport = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/payout/export`, payload, {
		responseType: 'blob',
	});
};

const summary = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/transaction/total`, payload);
};

export default {
	list,
	listExport,
	listPayout,
	listPayoutExport,
	summary,
};
